import React from 'react';
import { FiMapPin, FiCheck } from 'react-icons/fi';
import SafeIcon from '../components/SafeIcon';
import PageHeader from '../components/shared/PageHeader';
import CtaSection from '../components/shared/CtaSection';

const ServiceAreas = () => {
  const areas = [
    { name: "Montreal", desc: "Full coverage across all boroughs, including Downtown, Plateau, and Rosemont." },
    { name: "Laval", desc: "Rapid response times for all Laval neighborhoods." },
    { name: "West Island", desc: "Dedicated service teams covering Pointe-Claire, Dorval, Kirkland, and DDO." },
    { name: "South Shore", desc: "Serving Longueuil, Brossard, Boucherville, and surrounding areas." },
    { name: "Vaudreuil-Dorion", desc: "Extended coverage for the off-island suburbs." },
    { name: "North Shore", desc: "Service available in Blainville, Rosemère, and Terrebonne." }
  ];

  return (
    <div className="flex flex-col min-h-screen">
      <PageHeader 
        title="Areas We Serve" 
        subtitle="NorthPeak provides fast, reliable HVAC service across the Greater Montreal area."
        image="https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&q=80&w=2000"
      />

      <section className="section-padding bg-bg">
        <div className="container-custom">
          <div className="flex flex-col lg:flex-row gap-12">
            
            {/* List Side */}
            <div className="lg:w-1/2">
              <h2 className="text-3xl font-bold mb-6">Local Experts, Fast Response</h2>
              <p className="text-lg text-muted mb-8">
                When your heating or cooling system fails, you need a company that can reach you quickly. We have technicians stationed across the metropolitan area to ensure prompt service.
              </p>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {areas.map((area, idx) => (
                  <div key={idx} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:border-primary transition-colors">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="bg-blue-50 p-2 rounded-full text-primary">
                        <SafeIcon icon={FiMapPin} />
                      </div>
                      <h3 className="font-bold text-lg">{area.name}</h3>
                    </div>
                    <p className="text-sm text-muted">{area.desc}</p>
                  </div>
                ))}
              </div>

              <div className="mt-8 p-6 bg-blue-50 rounded-xl border border-blue-100 flex items-start gap-4">
                <SafeIcon icon={FiCheck} className="text-2xl text-secondary flex-shrink-0 mt-1" />
                <div>
                  <h4 className="font-bold text-primary mb-1">Don't see your city?</h4>
                  <p className="text-sm text-muted">Give us a call at (514) 555-0122. We often extend our service boundaries for installations or specific project requests.</p>
                </div>
              </div>
            </div>

            {/* Map Placeholder Side */}
            <div className="lg:w-1/2">
               <div className="bg-white p-2 rounded-2xl shadow-md h-full min-h-[400px] border border-gray-200 relative overflow-hidden group">
                  <img 
                    src="https://images.unsplash.com/photo-1524661135-423995f22d0b?auto=format&fit=crop&q=80&w=1000" 
                    alt="Map of Montreal" 
                    className="w-full h-full object-cover rounded-xl"
                  />
                  {/* Overlay to make it look like a stylized map area */}
                  <div className="absolute inset-0 bg-primary/10 rounded-xl group-hover:bg-transparent transition-colors duration-500"></div>
                  
                  {/* Fake map pins */}
                  <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-accent text-4xl drop-shadow-md animate-bounce">
                    <SafeIcon icon={FiMapPin} />
                  </div>
                  <div className="absolute top-1/2 left-1/3 text-primary text-3xl drop-shadow-md">
                    <SafeIcon icon={FiMapPin} />
                  </div>
                  <div className="absolute bottom-1/3 right-1/3 text-primary text-3xl drop-shadow-md">
                    <SafeIcon icon={FiMapPin} />
                  </div>

                  <div className="absolute bottom-4 left-4 right-4 bg-white/90 backdrop-blur-sm p-4 rounded-lg text-center shadow-lg">
                    <span className="font-bold text-primary">Interactive Map Loading...</span>
                  </div>
               </div>
            </div>

          </div>
        </div>
      </section>

      <CtaSection />
    </div>
  );
};

export default ServiceAreas;